import * as React from 'react';
import type { IconProps } from './types';

export const ImageSparkIcon = (props: IconProps & { isActive?: boolean }) => {
  const { color = 'currentColor', isActive = false, size = 24, ref, ...other } = props;
  const gradientId = React.useId();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      {isActive && (
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#7B6AE0" />
            <stop offset="100%" stopColor="#FFBB89" />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.625 12.9375V22.3125H1.6875V6.375H11.0625M1.6875 16.7342L5.67188 12.7498L10.4531 17.5311L12.8438 15.1404L17.625 19.9217M12.9375 5.90625C15.8021 5.90625 18.0938 3.61459 18.0938 0.75C18.0938 3.61459 20.3854 5.90625 23.25 5.90625C20.3854 5.90625 18.0938 8.19791 18.0938 11.0625C18.0938 8.19791 15.8021 5.90625 12.9375 5.90625Z"
        stroke={isActive ? `url(#${gradientId})` : color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
